import { render, staticRenderFns } from "./InviteMember.vue?vue&type=template&id=6a45f7e0"
import script from "./InviteMember.vue?vue&type=script&lang=js"
export * from "./InviteMember.vue?vue&type=script&lang=js"
import style0 from "./InviteMember.vue?vue&type=style&index=0&id=6a45f7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports